import React, { useMemo, useState } from "react"
import { Input } from "reactstrap"

const PayloadAutocomplete = ({
  value,
  onChange,
  onCommit,
  options,
  placeholder,
  minChars = 1,
  maxOptions = 12,
}) => {
  const [focused, setFocused] = useState(false)
  const [hasTyped, setHasTyped] = useState(false)
  const query = value || ""

  const matches = useMemo(() => {
    if (!hasTyped || query.length < minChars) return []

    const normalizedQuery = query.toLowerCase()
    return options
      .filter(option => {
        const optionValue = option.value.toLowerCase()
        const optionLabel = (option.label || "").toLowerCase()
        return optionValue.includes(normalizedQuery) || optionLabel.includes(normalizedQuery)
      })
      .slice(0, maxOptions)
  }, [hasTyped, maxOptions, minChars, options, query])

  const showOptions = focused && matches.length > 0

  const handleSelect = option => {
    // Don't toggle `focused`: the option button uses preventDefault on
    // mousedown so the input keeps DOM focus. Clearing `hasTyped` is enough
    // to hide the menu until the user types again.
    setHasTyped(false)
    if (onCommit) onCommit(option.value)
    else onChange(option.value)
  }

  const handleKeyDown = event => {
    if (event.key !== "Enter" || !onCommit) return
    event.preventDefault()
    if (query) {
      onCommit(query)
      setHasTyped(false)
    }
  }

  return (
    <div className="payload-autocomplete">
      <Input
        bsSize="sm"
        type="text"
        value={query}
        placeholder={placeholder}
        autoComplete="off"
        onFocus={() => {
          setFocused(true)
          setHasTyped(false)
        }}
        onBlur={() => {
          window.setTimeout(() => setFocused(false), 120)
        }}
        onChange={event => {
          setHasTyped(true)
          onChange(event.target.value)
        }}
        onKeyDown={handleKeyDown}
      />
      {showOptions && (
        <div className="payload-autocomplete-menu">
          {matches.map(option => (
            <button
              key={`${option.value}-${option.label || ""}`}
              type="button"
              className="payload-autocomplete-option"
              onMouseDown={event => {
                event.preventDefault()
                handleSelect(option)
              }}
            >
              <span className="payload-autocomplete-path">{option.value}</span>
              {option.label && (
                <span className="payload-autocomplete-sample">{option.label}</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}

export default PayloadAutocomplete
